const insuranceRequestRelatedWizard = require('./insuranceRequestWizard/insuranceRequestRelatedWizard');
const insuranceRequestRelatedRNCWizard = require('./insuranceRequestWizard/insuranceRequestRelatedRNCWizard');
const insuranceRequestWizard = require('./insuranceRequestWizard/insuranceRequestRelatedWizard');
const myProfileDocumentationInsurancesView = require('./myProfileDocumentationInsurancesView/myProfileDocumentationInsurancesView');

module.exports = {
    insuranceRequestRelatedWizard,
    insuranceRequestRelatedRNCWizard,
    insuranceRequestWizard,
    myProfileDocumentationInsurancesView
};
